var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.38046C0 1.06536 1.11914 -0.000488281 2.5 -0.000488281H17.5C18.8789 -0.000488281 20 1.06536 20 2.38046V11.9043C20 13.2175 18.8789 14.2852 17.5 14.2852H2.5C1.11914 14.2852 0 13.2175 0 11.9043V2.38046ZM1.875 2.38046V3.20264L8.61328 8.4705C9.41797 9.10294 10.582 9.10294 11.3867 8.4705L18.125 3.20264V2.34698C18.125 2.05308 17.8438 1.75174 17.5 1.75174H2.5C2.15469 1.75174 1.875 2.05308 1.875 2.34698V2.38046ZM1.875 5.51291V11.9043C1.875 12.2317 2.15469 12.4995 2.5 12.4995H17.5C17.8438 12.4995 18.125 12.2317 18.125 11.9043V5.51291L12.5781 9.8507C11.0781 11.0226 8.92188 11.0226 7.38672 9.8507L1.875 5.51291Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.88f5108046d4bc6f7aa6c56369fca1db.svg";
export { ForwardRef as ReactComponent };